import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CONFIG from "../../../utils/config";
import _ from "lodash";
import {
  getUsefulCourses,
  getUsefulCoursesClear,
} from "../../../redux/courses/actions";
import {
  PriceForSession,
  ProductCardPriceInfo,
  PurchasedOn,
  SessionKeys,
  convertMinutesToHoursAndMinutes,
  convertSecondsToMins,
  convertTimeFormat,
  getProcureInfo,
  redirectToPageUtil,
} from "../../../utils/AppUtils";
import { useNavigate } from "react-router";
import CommonComponentEntity from "./CommonComponentEntity";
import useLogin from "../../../custom-hooks/useLogin";

const UsefulCourses = ({fetchData}) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const usefulCoursesDataResponse = useSelector(
    (state) => state.courses.usefulCourses
  );

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (fetchData) getUsefulCoursesData();
    // return () => {
    //   dispatch(getUsefulCoursesClear());
    // };
  }, [fetchData]);

  const [newCardData, setNewCardData] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA
  );

  const { isLoggedIn } = useLogin();
  const authBroker = useSelector((state) => state.auth.authBroker);

  const [courseData, setCourseData] = useState({});

  const formatProductCardData = (coursesList) => {
    let prodArr = [];
    for (let course of coursesList) {
      let tags = [];
      let btnTitle = "Start course";
      if (course?.provider) {
        tags.push(course?.provider?.display_name);
      }
      tags.push("Course");

      tags.push(`${course?.module} Module${course?.module > 1 ? "s" : ""}`);

      if (course.second) {
        tags.push(convertTimeFormat(course.second, true));
      }

      if (course.progress > 0 && course.progress < 100) {
        btnTitle = "Resume course";
      } else if (course.progress >= 100) {
        btnTitle = "Revisit course";
      }

      let priceInfo = getProcureInfo(course.purchased_info);
      course.priceInfo = priceInfo;
      course.isLoggedIn = isLoggedIn;
      course.is_home = true;
      prodArr.push({
        id: _.toString(course?.product_id),
        is_like: course?.is_like ? course?.is_like : false,
        is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
        is_wishlist: course?.is_addtowishlist,
        dbId: course?.list_id,
        productType: course?.type,
        productOrigin: course?.source,
        title: course?.title,
        logoURL: course.provider?.provider_img,
        logoAltText: "VD",
        bannerURL: course?.thumbnail,
        tagsArray: tags,
        description: course?.description,
        btnTitle: btnTitle,
        progress: course.crs_progress,
        showProviderIcon: true,
        showLikeMenu: true,
        btnAction: () =>
          redirectToPageUtil(
            course,
            navigate,
            authBroker,
            setCourseData,
            dispatch
          ),
        descAction: {},
        bannerAction: () =>
          redirectToPageUtil(
            course,
            navigate,
            authBroker,
            setCourseData,
            dispatch
          ),
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        showHeader: true,
        showBody: course?.description ? true : false,
        showFooter: true,
        showProgresss: true,
        cardClassName: "",
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        isLoading: false,
        priceInfo
      });
    }
    console.log("PROD ARR", prodArr);
    setNewCardData(prodArr);
  };

  useEffect(() => {
    if (!_.isEmpty(usefulCoursesDataResponse)) {
      if (usefulCoursesDataResponse.status === "success") {
        const list1 = usefulCoursesDataResponse.payload.payload?.list;
        console.log("use--list", list1);
        if (!_.isEmpty(list1)) {
          formatProductCardData(list1);
          setIsLoading(false);
        } else {
          setNewCardData([]);
          setIsLoading(false);
        }
      } else {
        setNewCardData([]);
        setIsLoading(false);
      }
    }
  }, [usefulCoursesDataResponse]);

  const getUsefulCoursesData = () => {
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setIsLoading(true);
    dispatch(
      getUsefulCourses({
        module: "usefulCourses",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          entity_type: "course",
          origin: "xsel",
        },
      })
    );
  };

  useEffect(() => {
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  }, []);

  return (
    <>
      <CommonComponentEntity
        // isLoading={isLoading}
        newCardData={newCardData}
        heading={"Courses you may find useful"}
        subHeading={"Based on what other learners are looking at"}
        viewAllAction={"/learn/courses?tab=1"}
        type={"course"}
      />
    </>
  );
};

export default UsefulCourses;
